import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KeycloakOptions, KeycloakService } from 'keycloak-angular';

import { SessionService } from './session.service';
import { IAuthConfig } from './defs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public working$: BehaviorSubject<boolean>;
  public loggedIn: boolean;

  private config: IAuthConfig;

  constructor(
    private session: SessionService,
    private keycloak: KeycloakService
  ) {
    this.working$ = new BehaviorSubject(true);
  }


  private updateSessionFromKeycloak(instance: Keycloak.default): void {

    const sessionData = this.session.getSession();
    const profile = instance.profile;

    let avatar = null;
    if ((profile as any).attributes?.avatar?.length) {
      avatar = (profile as any).attributes.avatar[0];
    }

    this.session.setSession({
      ...sessionData,
      userName: profile.username,
      firstName: profile.firstName,
      lastName: profile.lastName,
      avatar,
      token_info: {
        when: new Date(),
        token: instance.token,
        refreshToken: instance.refreshToken
      },
      roles: instance.realmAccess?.roles
    });

    this.working$.next(false);
    
  }


  public initialize(config: IAuthConfig): void {

    this.config = config;

    const sessionData = this.session.getSession() || {} as any;

    if (!config) {
      console.log("Error 1");
      throw new Error('Error initializing Dash button, config not set');
    }

    if (!config.clientId) {
      console.log("Error 2");
      throw new Error('Error initializing Dash button, keycloak.clientId not set');
    }

    if (!config.realm) {
      console.log("Error 2");
      throw new Error('Error initializing Dash button, keycloak.realm not set');
    }

    if (!config.url) {
      console.log("Error 2");
      throw new Error('Error initializing Dash button, keycloak.url not set');
    }

    let keycloakUrl = config.url;
    if (!keycloakUrl.endsWith('/')) {
      keycloakUrl += '/';
    }

    keycloakUrl += 'auth';

    const keycloakOptions: KeycloakOptions = {
      config: {
        clientId: config.clientId,
        realm: config.realm,
        url: keycloakUrl,
      },
      initOptions: {
        flow: 'standard',
        pkceMethod: 'S256',
        onLoad: 'check-sso',
        checkLoginIframe: config.frameUrl ? true : false,
        silentCheckSsoRedirectUri: config.frameUrl,
        enableLogging: true,
      },
      enableBearerInterceptor: false,
      loadUserProfileAtStartUp: true,
    };
    // console.log("sessionData");
    // console.log(sessionData);
    if (sessionData.token_info) {
      keycloakOptions.initOptions.token = sessionData.token_info.token;
      keycloakOptions.initOptions.refreshToken = sessionData.token_info.refreshToken;
    }

    this.keycloak.init(keycloakOptions)
      .then(loggedIn => {

        this.loggedIn = loggedIn;
        console.log("this.loggedIn: " + this.loggedIn)
        if (loggedIn) {
          
          //we are logged in
          this.loadUserProfile();

        } else if (sessionData.token_info) {

          // try auto login
          this.doLogin();

        } else {

          // we are totally logged out
          this.working$.next(false);
        }

      });

  }

  private loadUserProfile(): void {
    console.log("LoadUserProfile")
    const instance = this.keycloak.getKeycloakInstance();
    this.updateSessionFromKeycloak(instance);
  }


  public isAuthenticated(): boolean {
    return this.loggedIn;
  }

  public doLogin(): void {

    if (this.loggedIn) {
      return;
    }

    const session = this.session.getSession();

    // delete session so we don't enter on an infinite loop
    this.session.clearSession();

    if (this.config.loginUrl) {
      window.location.href = this.config.loginUrl;
      return;
    }

    this.keycloak.login({
      loginHint: session?.userName
    });
  }

  public doLogout(): void {

    if (this.loggedIn) {

      this.loggedIn = false;
      this.session.clearSession();

      this.keycloak.logout(this.config.logoutUrl || window.location.href)
      .catch(err => {
        console.log(err);
      })

    }
  }


}
